export default __webpack_public_path__ + "static/media/SIFA_NL_SEQ06.734a74ee.mp3";